import { dateColDefs } from '@/constants/ag-grid-scenario-builder.constant'
import { optimizationDefaultColDefs } from '@/constants/portfolioOptimization.constant'
import { ColDef } from '@ag-grid-community/core'

export const CashflowReportColumns = [
  {
    ...{ ...optimizationDefaultColDefs, ...dateColDefs },
    floatingFilter: false,
    headerName: 'Date',
    field: 'flow_date',
    filter: 'agDateColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    floatingFilter: false,
    headerName: 'Carryover',
    field: 'carryover',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    floatingFilter: false,
    headerName: 'Coupon',
    field: 'coupon',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    floatingFilter: false,
    headerName: 'Principal',
    field: 'principal',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    floatingFilter: false,
    headerName: 'Inflow',
    field: 'inflow',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    floatingFilter: false,
    headerName: 'Liability',
    field: 'liability',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    floatingFilter: false,
    headerName: 'Net',
    field: 'net',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    floatingFilter: false,
    headerName: 'Balance',
    field: 'balance',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
] as ColDef[]
